import { useEffect } from "react";

const PIXEL_ID = "1637568227842000";

export default function MetaPixel() {
  useEffect(() => {
    // Prevent duplicate initialization
    if (window.fbq) return;

    // Create the Meta Pixel function
    const n = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };

    if (!window._fbq) {
      window._fbq = n;
    }

    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    // Register Meta Pixel globally
    window.fbq = n;

    // Load Meta Pixel script
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://connect.facebook.net/en_US/fbevents.js";

    const firstScript = document.getElementsByTagName("script")[0];

    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Initialize Meta Pixel and track the first page view
    window.fbq("init", 1637568227842000);
    window.fbq("track", "PageView");
  }, []);

  return null;
}
